module.exports = {
    pleaseWait:'Please wait',
    loading:'loading',
    Billing:'Billing',
    billingTips:'Your Purchased History',
    ID:'ID',
    FAQ:'FAQ',
    TC:'T&C',
    Copyright:'© 2026 All Rights Reserved.',
    GenerateImage:'Generate Image',
    generateTips1:'Our AI image generator brings imagination to life, producing stunning art, illustrations, and photos in seconds. Unleash creativity and express yourself in new ways with the power of AI. Explore endless possibilities, from crafting unique marketing materials to creating beautiful artwork, all with supreme ease and efficiency.',
    generateTips2:'Enter a few words below, and watch Snapai transform text into incredible art.',
    Prompt:'Prompt',
    PromptTips1:'Tell AI what to draw.',
    PromptTips2:'Tips: describe mood and lighting. See page tips for more.',
    PromptTips3:'Note: AI may not follow instructions and cannot count.',
    Generate:'Generate',
    ChancesLeft:'Chances Left',
    BuyChances:'Buy More Chances',
    generateImageTips1:'Input what you want',
    generatePromptsTips1:'Input what you don\'t want',
    indexTips1:'Daily Free Chance <br /> Available!',
    indexTips2:'Choose one of these',
    ImageRestorer:'Image Restorer',
    Continue:'Continue',
    language0:'Language',
    language:'Choose Language',
    languageTips:'Choose your language here',
    Submit:'Submit',
    change:'Change',
    English:'English',
    Myanmar:'Sinhala',
    Login:'Login',
    Logout:'Log out',
    getCode:'Send',
    loginTips:'Enter a phone number',
    profile:'Profile',
    phoneNumber:'Phone Number',
    SubscribedSince:'Subscribed since',
    RemainingChances:'Remaining chances',
    cgtips2:'Only 149ks/daily,<br />please click OK to subscribe.',
    cgtips2W:'Only 599ks/weekly,<br />please click OK to subscribe.',
    cgtips2M:'Only 1999ks/monthly,<br />please click OK to subscribe.',
    OK:'OK',
    PictureRestorer:'Picture Restorer',
    PictureTips1:'Restore, sharpen, and repair pictures with AI. Snapai builds on the latest research to automatically remove scratches, sharpen colors, and enhance faces, transforming damaged photos into cherished memories. Our free service repairs both color photos and black & white ones.',
    Upload:'Upload',
    PictureTips2:'Has Scratch?',
    Restore:'Restore',
    uploadTips:'Please upload pictures',
    PurchaseChances:'Purchase Chances',
    History:'History',
    purchaseTips1:'Your total chances',
    purchaseTips2:'One Time Purchase',
    Daily:'Daily',
    Weekly:'Weekly',
    OneTime:'One Time',
    Purchase:'Purchase',
    DailyKyats:'169 Kyats',
    WeeklyKyats:'699 Kyats',
    OneTimeChance:'149 Ks/Chance',
    Subscribe:'Subscribe',
    purchaseTips3:'Please choose how many <strong>CHANCES</strong> to buy.',
    BuyNow:'Buy Now',
    logout:'Logout',
    petTitle1:'AI Pets Anime',
    petTitle2:'Choose Style',
    petContent1:' transforms your beloved pet’s photo into a whimsical, anime-style masterpiece. Perfect for pet lovers and anime enthusiasts, Snapai offers a fun and personalized way to celebrate your furry friends.',
    sexTitle1:'AI Personal Anime',
    sexTitle2:'Choose Gender',
    sexContent1:'Brings your imagination to life by generating anime-style photos based on written prompts. Whether you\'re a fan of anime, a storyteller, or a designer, AI Anime Photo empowers you to create vibrant, high-quality anime-style visuals effortlessly, blending advanced AI with your unique vision.',
    sexContent2:'Choose the gender below and enter the prompt below. Watch Snapai transfor text into incredible art.',
    Female:'Female',
    Male:'Male',
    Style1:'Style 1',
    Style2:'Style 2',
    Style3:'Style 3',
    Comic:'Comic',
    Disney:'Disney',
    Ghibli:'Ghibli',
    Animalanime:'Selfie Anime',
    HumanAnime:'Human Anime',
    Guidance:'Guidance',
    PetAnime:'Pet Anime',
    landTips1:'Generate Stunning Photos &',
    landTips2:'WIN BIG PRIZES!',
    landTips3:'Transform your imagination into reality with SnapAI! From stunning photo generation to artistic masterpieces, SnapAI empowers you to create visuals like never before. Dive into a world of limitless possibilities.',
    show401tip:'Balance not enough',
    show400dailytip:'Time out, please send "ON1" to 548 to win the big prize.',
    show400weeklytip:'Time out, please send "ON7" to 548 to win the big prize.',
    register:'Register',
    invitation:'Invitation',
    invitationTips:'Copy and send invite using the link below',
    InviteNow:'Invite Now',
    copySuccess:'Copy Success!',
    process:'Generating',
    downTips1:'Please copy the link into browser and download.',
    copyLink:'Copy link',
    free:'Free',
    aiAnimeTitle:'AI Couples Anime',
    aiAnimeCt1:'Transform your original couple photos into anime-style images, making your romantic memories even more fun. Whether you\'re an anime enthusiast or a designer, AI Anime Photo allows you to effortlessly create meaningful and high-quality anime-style visuals, perfectly blending advanced AI technology with your romantic moments. ',
    aiAnimeCt2:'Select the style below and upload your original photo to watch Snapai transform your sweet memories into stunning artworks.',
    comingsoonT:'coming soon',
    SubscribePackage:'Subscribe Package',
    landfont1:'Turn photo into stunning anime artwork.',
    landfont2:'Transform your couple photos into beautiful anime characters.',
    landfont3:'Write a prompt to generate beautiful images',
    landfont4:'Turn your pets into adorable anime characters with AI magic!',
    landfont5:'Rediscover your memories with AI-powered photo restoration.',
    SmartCutout:'Smart Cutout',
    letgo:'Let’s Go',
    IpIMage:'ID Photo',
    IpIMageTip:'Need a license or ID photo created? We’ve got you covered!',
    IpIMage_content:'The original image uploaded for the ID photo must ensure that the face of the person is clear, without any obstruction, and the shoulders are level and even. Otherwise, the generation may fail. ',
    snapbot:'SnapBot',
    snapbot_hi:'Hi, I’m SnapBot.',
    help_today:'How can I help you today?',
    think_ip:'🤖 Thinking...',
    Coloring_old_photos:'Image Recolor',
    Coloring_old_photos_tips:'Bring your memories back to life by restoring color\n' +
      'to your vintage photos. Our AI-powered tool\n' +
      'automatically analyzes and adds natural color tones,\n' +
      'preserving the charm of the original while\n' +
      'enhancing its visual appeal.\n',
    Coloring_old_photos_tips2:' Bring your old photos to life with AI-powered color restoration.',
    BgFusion:'Smart Blend',
    BgFusion_tips2:'Customize your photo with a background of your choice',
    BgFusion_tips:'Customize your photo with a background of your choice.\n' +
      'Our smart AI replaces the original backdrop\n' +
      'and blends your image naturally into the new scene ',
    Upload_bg:'Upload Background',
    Upload_pt:'Upload Portrait',
    Recolor:'Recolor',
    snapbotTips1:'Fast Search Results',
    snapbotTips2:'Natural Language processing',
    snapbotTips3:'Big Data Analysis',
    snapbotTips4:'AI-powered Algorithms',
    snapbotInput1:'Tap here to start with SnapBot',
    white:'white',
    blue:'blue',
    '1 inch':'1 inch',
    '2 inches':'2 inch',
    '3 inches':'3 inch',
    landTips11:'Create Awesome Photos &',
    ChangeHairstyle:'Hairstyle Magic',
  ChangeHairstyle_short:'Create and try out your Imagined Hairstyles',
  ChangeHairstyle_content_1:'The snapai app offers a feature for changing hairstyles, allowing users to try on different haircuts in real-time or via uploaded photos. This feature leverages AI technology to analyze the user’s facial features and suggest hairstyles that suit their face shape, preferences, and style. Users can experiment with various looks, ranging from subtle changes to bold, dramatic transformations, giving them a virtual preview before committing to an actual change. The app provides an easy and fun way for users to explore different hairstyles and find the perfect one for them.',
  ChangeHairstyle_content_2:'Choose your favorite hairstyle below and add your own photo. You will get a beautiful and clear image.',
  Result:'Result',
  Original:'Original',
  unsub_tip:'To unsubscribe, send OFF to 548',
  sub_tip:'For subscription,send "ON1" or "ON7" to 548',
  longHairEffects:'Long Hair Effect',
  longHairEffects_tip:'Try the Long Hair Effect it gives you a natural and attractive hairstyle. This effect creates the look of longer hair for you.\n' +
    'Smooth & shiny\n' +
    'Natural-looking length\n' +
    'Perfect for any outfit, Look your best every day with the Long Hair Effect!',
  VIDEO:'VIDEO',
  image_video:'Image To Video',
  image_video_tip:'This function turns a still photo into a lively 1–3 minute animated video, adding natural facial expressions and movements to make the image come alive. Users can also check previously generated videos from their history.',
  word_video:'Word To Video',
  word_video_tip:'This function transforms the text you have written into a dynamic, lifelike video using AI technology, allowing it to reflect your preferred style and expression. It may take 1–3 minutes to generate the video, and previously created videos can be reviewed in the history record.',
  word_video_input:"Describe the style and appearance of the video you want to create.",
  image_video_input:"Describe the style and appearance of the photo you want to create.",
  aiDressUp:"AI DressUp",
  aiDressUp_tip:"With AI Dress Up, change your look instantly!\n" +
    "Upload your photo and try endless outfits—\n" +
    "traditional, formal, or trendy. The SnapAI fits clothes\n" +
    "naturally to your body, letting you preview\n" +
    "new styles and have fun exploring fashion.",
  singleheart:"Love You Effect",
  singleheart_desc:"Share your affection! Add a sweet and romantic heart-shaped effect to your video and show someone you care.",
  aiVividScene:"Vivid AI Scene",
  aiVividScene_desc:"Capture the perfect photo for every mood and season with the new AI Scene Creator! If you have just one clear photo of your face, you can easily select various Backgrounds, Styles, and Color Tones to generate stunning, richly colored photos in countless scenarios. Instantly place yourself in a summer beach scene, a nighttime cityscape, a rainy day street, or any fantasy setting, all without needing to be there in person.",
  pic_size_limit :"Images cannot exceed 5MB",
  spin_tip_1 :"Don't miss your chance!",
  spin_tip_2 :"The spin wheel only provide in daily quest campaign",
  close :"close",
  spin:'Spin',
  SpinChances:'Spin Chances',
  date:'Date',
  Prizes:'Prizes',
  nochance:'You don\'t have enough chance',
  WinnerList:'Winner List',
  Congratulations:"Congratulations !you won",
  Confirm:"Confirm",
  spinTips2:'Daily Free Spin!',
  spinTips3:'Claim your FREE Lucky Spin Token and try your luck today!',
  spinTips4:'Get My Token',
  No:'No',
  not_win:"Thank you for playing. Better Luck next time!",
  win_tip:'Tap below to collect your reward',
  unsubscribe:'Unsubscribe',

}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js